import React, { useState } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ElectedPopup from "./electedPopup";
import UndecidedPopup from "./undecidedPopup";
import VacantPopup from "./vacantPopup";
import * as staffActions from "../actions/staffActions";
import { fieldNames } from "../utilities/constants";
import utils from "../utilities/utils";

const {
  RACE,
  GENDER,
  CHAIRPERSONSHIP,
  LEGISLATIVE_CONFERENCE,
  COMMITTEE_ASSIGNMENTS_AND_CAUCUSES,
  LAST_NAME,
  DISTRICT_REPRESENTED,
  REGION,
  PREVIEW,
} = fieldNames;

function LegislativePopup(props) {
  const [showModal, setShowModal] = useState(false);

  function buttonHandler(event) {
    event.preventDefault();
    const governmentBody = props.governmentBody;

    if (governmentBody.includes("Senate")) {
      props.actions.fetchStaff("Senate Staff", props.info.id);
    } else if (governmentBody.includes("Assembly")) {
      props.actions.fetchStaff("Assembly Staff", props.info.id);
    } else if (governmentBody === "NYC Council") {
      props.actions.fetchStaff("NYC Council Staff", props.info.id);
    }
    open();
  }

  function raceHide() {
    let hide = false;
    let raceIdendity = props.info.fields[RACE] || ["Unknown"];
    if (props.raceFilter.length > 0) {
      hide = true;
      raceIdendity.forEach((race) => {
        if (props.raceFilter.includes(race)) {
          hide = false;
        }
      });
    }
    return hide;
  }

  function genderHide() {
    const gender = props.info.fields[GENDER]?.[0] || "Unknown";
    return (
      props.genderFilter.length > 0 && !props.genderFilter.includes(gender)
    );
  }

  function regionHide() {
    const regionFilter = props.regionFilter;
    const regions = utils.trimRegion(props.info.fields[REGION]);
    let showRegion = false;
    regionFilter &&
      regions.forEach((region) => {
        if (regionFilter.includes(region)) {
          showRegion = true;
        }
      });
    return regionFilter && regions && regionFilter.length > 0 && !showRegion;
  }

  function committeeChair() {
    const chairpersonship = props.info.fields[CHAIRPERSONSHIP];
    const committeeFilter = props.committeeFilter;
    if (committeeFilter.length > 0 && chairpersonship) {
      let filterCommittees = committeeFilter;
      let chair = "";
      chairpersonship.forEach((committee) => {
        filterCommittees.forEach((filterCommittee) => {
          if (filterCommittee === committee) {
            chair = "true";
          }
        });
      });
      return chair;
    }
  }

  function checkCommittees(filterCommittees) {
    if (props.committees) {
      let match = filterCommittees.filter((committee) => {
        return props.committees.includes(committee);
      });
      return match.length > 0;
    }
  }

  function committeeHide() {
    const committeeFilter = props.committeeFilter;
    return committeeFilter.length > 0 && !checkCommittees(committeeFilter);
  }

  function filter() {
    if (raceHide() || genderHide() || regionHide() || committeeHide()) {
      return {
        visibility: "hidden",
        opacity: 0,
        transition: "visibility 1s, opacity 1s linear",
      };
    }
  }

  function close() {
    setShowModal(false);
    props.actions.clearStaff();
  }

  function open() {
    setShowModal(true);
  }

  function setStyle() {
    let classes = props.classes;
    if (committeeChair()) {
      classes += " chair-outline";
    }

    if (classes.includes("asian") && classes.includes("republican")) {
      classes += " black-text";
    } else if (
      (classes.includes("white") && !classes.includes("black")) ||
      classes.includes("independent") ||
      classes.includes("republican") ||
      classes.includes("unknown")
    ) {
      classes += " white-text";
    }
    return classes;
  }

  return (
    <div>
      <button
        className={setStyle()}
        onClick={(event) => buttonHandler(event)}
        style={filter()}
      >
        {props.info.fields[LAST_NAME]}
      </button>
      {props.info.fields[LAST_NAME] === "Undecided" ? ( //renders popup for undecided position
        <UndecidedPopup
          district={props.info.fields[DISTRICT_REPRESENTED]}
          show={showModal}
          onHide={() => close()}
        />
      ) : props.info.fields[LAST_NAME] === "Vacant" ? (
        //renders popup for vacant position
        <VacantPopup
          fields={props.info.fields}
          show={showModal}
          onHide={() => close()}
          onClick={() => close()}
        />
      ) : props.info.fields[PREVIEW] ? ( //renders popup for previews
        <ElectedPopup
          fields={props.info.fields}
          staff={props.staff}
          show={showModal}
          onHide={() => close()}
          onClick={() => close()}
          preview={true}
          governmentBody={props.governmentBody}
        />
      ) : (
        //renders popup for known position
        <ElectedPopup
          fields={props.info.fields}
          staff={props.staff}
          show={showModal}
          onHide={() => close()}
          onClick={() => close()}
          preview={false}
          governmentBody={props.governmentBody}
        />
      )}
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  let race = ownProps.info.fields[RACE] || ["unknown"];

  let legislativeConference = ownProps.info.fields[LEGISLATIVE_CONFERENCE];

  let legislativeConferenceStr =
    legislativeConference && typeof legislativeConference === "string"
      ? legislativeConference.toLowerCase().slice(0, -11)
      : "unknown";

  // turn into "Arab-Asian" for use in class names
  if (race && race.includes("Arab/Asian")) {
    race[race.indexOf("Arab/Asian")] = "Arab-Asian";
  }

  let committees = ownProps.info.fields[COMMITTEE_ASSIGNMENTS_AND_CAUCUSES];

  let staff = state.staff;
  let classes = "btn-circle ";
  let raceStr = race.sort().join("-").toLowerCase();

  if (legislativeConferenceStr.includes("undecided")) {
    classes += "undecided";
  } else if (
    raceStr.includes("unknown") ||
    legislativeConferenceStr.includes("unknown")
  ) {
    classes += "unknown";
  } else {
    classes += `${raceStr + "-" + legislativeConferenceStr}`;
  }

  //turn back into Arab/Asian for use in popup
  if (race && race.includes("Arab-Asian")) {
    race[race.indexOf("Arab-Asian")] = "Arab/Asian";
  }

  return {
    classes,
    committees,
    staff,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(staffActions, dispatch) };
}

const componentCreator = connect(mapStateToProps, mapDispatchToProps);

export default componentCreator(LegislativePopup);
